import Axios from "./axios";

const resource = "terms-and-conditions";
const resellerResource = "reseller-terms-and-conditions";

export default {
  get() {
		return Axios.get(`${resource}`);
	},
	showViaSlug(slug) {
		return Axios.get(`${resource}/slug/${slug}`);
	},
	resellerGetViaSlug(slug) {
		return Axios.get(`${resellerResource}/slug/${slug}`);
	},
	resellerGet(params) {
		return Axios.get(`${resellerResource}`, params);
	}
}